import api from '@/api'

const { $student, $academic } = api;

export const { $students } = $student;

export const { $setting } = $academic